export const doctorNameCreator = (
  fullName,
  provider,
  hideSalutation,
) => {
  const finalFullName = (fullName || '').trim();
  if (finalFullName) {
    return provider
      ? finalFullName
      : finalFullName.startsWith('Dr.')
      ? hideSalutation
        ? finalFullName.replace('Dr.', '').trim()
        : finalFullName
      : hideSalutation
      ? finalFullName
      : `Dr. ${finalFullName}`;
  }
  return '';
};
